/**
 * React Query keys for orders management
 */

export const queryKey = {
  getOrderList: 'ORDER_MANAGEMENT_GET_ORDERS_LIST',
  getOrderDetail: 'ORDER_MANAGEMENT_GET_ORDER_DETAIL',
  getOrderStatistics: 'ORDER_MANAGEMENT_GET_STATISTICS',
  getOrderCountByStatus: 'ORDER_MANAGEMENT_GET_ORDER_COUNT_BY_STATUS',
  getAllOrderCountsByStatus: 'ORDER_MANAGEMENT_GET_ALL_ORDER_COUNTS_BY_STATUS',
  getTotalOrdersCount: 'ORDER_MANAGEMENT_GET_TOTAL_ORDERS_COUNT',
  getTotalOrdersValue: 'ORDER_MANAGEMENT_GET_TOTAL_ORDERS_VALUE',
  getOutstandingPaymentsValue: 'ORDER_MANAGEMENT_GET_OUTSTANDING_PAYMENTS_VALUE',
};
